<mat-form-field *ngIf="localConfig.control === 'datepicker'" 
        class="mat-field-width">
    <input matInput type="text"
            [matDatepicker]="datePicker"                
            placeholder="{{localConfig.label}}"
            [(ngModel)]="pseudoValue"
            (focus)="inputFocus = true"
            (blur)="blur($event)"
            (ngModelChange)="valueChanged($event)"
            [errorStateMatcher]="errorState"
            [min]="localConfig.minDate"
            [max]="localConfig.maxDate"
            [attr.required]="required ? 'required' : null"
            [disabled]="disabled"
                />
    <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
    <mat-datepicker #datePicker></mat-datepicker>
    <span matSuffix *ngIf="localConfig.tooltip">
        <app-field-tooltip-suffix [tooltip]="localConfig.tooltip" ></app-field-tooltip-suffix>
    </span>
    
    <mat-error>
        <span>{{localConfig.validation}}</span>
    </mat-error>
</mat-form-field>